import { axiosSecure, handleError, handleResponse, RequestResponse } from './config';

export const getCountries = async (): Promise<RequestResponse> => {
   return await axiosSecure.get('/countries/v2').then(handleResponse).catch(handleError);
};
